if (document.getElementsByClassName('tm-text').length) {
    const videos = document.querySelectorAll("iframe[src^='https://www.youtube.com']");

    if (videos.length) {
        videos.forEach((video) => {
            if (!video.closest('.tm-youtube-wrapper')) {
                let wrapper = document.createElement('div');
                wrapper.className = "tm-youtube-wrapper"
                video.parentNode.insertBefore(wrapper, video);
                wrapper.appendChild(video);
            }
        });
    }
}
